/* RESPONSIBLE TEAM: team-standalone */

import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default class FreshdeskConfigurationSerializer extends EmbercomBaseSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    ticketsIntegration: { embedded: 'always' },
  };
}

declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    'standalone/freshdesk-configuration': FreshdeskConfigurationSerializer;
  }
}
